import {Box, lineHeight, textAlign} from "@mui/system";
import kitchen2 from "./Icons/kitchen2.png";
import kitchen3 from "./Icons/kitchen3.png";
import kitchenMain from "./Icons/kitchenMain.png";
import {Collapse, Divider, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {KuhniKitchenCarousel} from "./UI/carousel/KuhniKitchenCarousel";
import ButtonWidthDivider from "./UI/button/ButtonWidthDivider";
import {kitchensCorner, kitchensStraight, advantages, stages, stats, news, questions} from "../data/DataFromKuhniVerso";
import Card from "./UI/Card";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {useNavigate} from "react-router-dom";
import {constantsErrorMessages} from "../Constants";
import ModalAlert from "./UI/table/customer-detales/ModalAlert";
import {
    fetchKitchenCarouselCards,
    getKitchenCarouselPageCount,
} from "../utils/kitchenCarouselFetch";
import FaqAnswerContent from "./FaqAnswerContent";

const STEP_CARD_WIDTH = 473;

const stepHoverImagePosition = {
    1: {top: "180px", left: `${(-160 / STEP_CARD_WIDTH) * 100}%`},
    2: {top: "-135px", left: `${(450 / STEP_CARD_WIDTH) * 100}%`},
    3: {top: "265px", left: `${(-130 / STEP_CARD_WIDTH) * 100}%`},
    4: {top: "-200px", left: `${(355 / STEP_CARD_WIDTH) * 100}%`},
};

const KITCHEN_CAROUSEL_BUTTON_GAP = 40;

const kitchenCarouselSectionSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    gap: `${KITCHEN_CAROUSEL_BUTTON_GAP}px`,
    "& > *": {
        flexShrink: 0,
    },
    "@media (max-width: 1450px)": {
        gap: `${KITCHEN_CAROUSEL_BUTTON_GAP}px`,
    },
    "@media (max-width: 1250px)": {
        gap: `${KITCHEN_CAROUSEL_BUTTON_GAP}px`,
    },
};

const kitchenCarouselWrapperSx = {
    width: "100%",
    flexShrink: 0,
};

const kitchenCarouselButtonSx = {
    display: "flex",
    justifyContent: "center",
    flexShrink: 0,
};

const MEDIA_MAX_1023 = "@media (max-width: 1023px)";
const MEDIA_MAX_599 = "@media (max-width: 599px)";
const MEDIA_MAX_760 = "@media (max-width: 760px)";
const MEDIA_MAX_500 = "@media (max-width: 500px)";
const MEDIA_MAX_400 = "@media (max-width: 400px)";
const MEDIA_MAX_360 = "@media (max-width: 360px)";

const blockHeadingMobileSx = {
    [MEDIA_MAX_599]: {
        fontSize: "32px",
    },
};

const blockHeadingSubMobileSx = {
    [MEDIA_MAX_599]: {
        fontSize: "26px",
    },
};

const heroHeadlineMainFontMobile599Sx = {
    fontSize: "36px",
};

const heroHeadlineSubFontMobile599Sx = {
    fontSize: "36px",
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
};

const heroBadgeBoxMobile599Sx = {
    width: "100%",
    flex: "1 1 auto",
    height: "auto",
    padding: "6px 12px",
};

const heroBadgesRowMobile400Sx = {
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    gap: "20px",
};

const heroHeadlineInlineWordMobile599Sx = {
    display: "inline",
    whiteSpace: "normal",
};

const heroHeadlineMainWordMobile599Sx = {
    ...heroHeadlineInlineWordMobile599Sx,
    display: "inline",
    maxWidth: "100%",
    paddingRight: "0.2em",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
};

const heroHeadlineKitchenWordMobile599Sx = {
    ...heroHeadlineInlineWordMobile599Sx,
    display: "inline-block",
    paddingRight: "0.2em",
};

const STEP_TABLET_CIRCLE = 74;
const STEP_TABLET_GAP = 20;
const STEP_TABLET_STEP_PAD = 72.5;
const STEP_MOBILE_CIRCLE = 60;
const STEP_MOBILE_GAP = 16;
const stepTabletLineLeft = `calc(${STEP_TABLET_STEP_PAD}px + ${STEP_TABLET_CIRCLE / 2}px)`;
const stepMobileLineLeft = `calc(50% - ${(STEP_MOBILE_CIRCLE + STEP_MOBILE_GAP + STEP_CARD_WIDTH) / 2 - STEP_MOBILE_CIRCLE / 2}px)`;
const stepMobileLineLeftNoPad = `${STEP_MOBILE_CIRCLE / 2}px`;

const TABLET_HEADLINE_MIN_VW = 744;
const TABLET_HEADLINE_MAX_VW = 1023;
const TABLET_HEADLINE_VW_RANGE = TABLET_HEADLINE_MAX_VW - TABLET_HEADLINE_MIN_VW;
const HERO_MOBILE_HEADLINE_MIN_VW = 599;
const HERO_MOBILE_HEADLINE_MAX_VW = 760;
const HERO_MOBILE_HEADLINE_VW_RANGE = HERO_MOBILE_HEADLINE_MAX_VW - HERO_MOBILE_HEADLINE_MIN_VW;
const STATS_MOBILE_MIN_VW = 599;
const STATS_MOBILE_MAX_VW = 760;
const STATS_MOBILE_VW_RANGE = STATS_MOBILE_MAX_VW - STATS_MOBILE_MIN_VW;

const MEDIA_HEADLINE_NOWRAP = "@media (min-width: 761px) and (max-width: 1023px)";

const heroHeadlineMainWordNowrapTabletSx = {
    [MEDIA_HEADLINE_NOWRAP]: {
        whiteSpace: "nowrap",
    },
};

const heroHeadlineWordBaseSx = {
    fontWeight: 800,
    lineHeight: 1.2,
    textTransform: "uppercase",
};

const heroHeadlineMainFontTabletSx = {
    fontSize: `clamp(46px, calc(46px + (100vw - ${TABLET_HEADLINE_MIN_VW}px) * 12 / ${TABLET_HEADLINE_VW_RANGE}), 58px)`,
};

const heroHeadlineSubFontTabletSx = {
    fontSize: `clamp(46px, calc(46px + (100vw - ${TABLET_HEADLINE_MIN_VW}px) * 6 / ${TABLET_HEADLINE_VW_RANGE}), 46px)`,
};

const heroHeadlineMainWordSx = {
    ...heroHeadlineWordBaseSx,
    fontSize: "58px",
    '@media (max-width: 1450px)': {
        fontSize: "clamp(36px, 8.056cqw, 58px)",
    },
    [MEDIA_MAX_1023]: {
        ...heroHeadlineMainFontTabletSx,
    },
    [MEDIA_MAX_599]: {
        ...heroHeadlineMainFontMobile599Sx,
    },
};

const heroHeadlineSubWordSx = {
    ...heroHeadlineWordBaseSx,
    fontSize: "50px",
    '@media (max-width: 1450px)': {
        fontSize: "clamp(32px, 6.944cqw, 50px)",
    },
    [MEDIA_MAX_1023]: {
        ...heroHeadlineSubFontTabletSx,
    },
    [MEDIA_MAX_599]: {
        ...heroHeadlineSubFontMobile599Sx,
    },
};

const heroHeadlineMainTabletSx = {
    display: "inline-block",
    [MEDIA_MAX_1023]: {
        display: "inline-block",
        ...heroHeadlineMainFontTabletSx,
        paddingRight: "0.2em",
        ...heroHeadlineMainWordNowrapTabletSx,
    },
    [MEDIA_MAX_599]: {
        display: "inline",
        whiteSpace: "normal",
        ...heroHeadlineMainWordMobile599Sx,
    },
};

const heroHeadlineKitchenTabletSx = {
    display: "inline-block",
    [MEDIA_MAX_1023]: {
        display: "inline-block",
        ...heroHeadlineMainFontTabletSx,
        paddingRight: "0.2em",
        ...heroHeadlineMainWordNowrapTabletSx,
    },
    [MEDIA_MAX_599]: {
        display: "inline-block",
        whiteSpace: "normal",
        ...heroHeadlineKitchenWordMobile599Sx,
    },
};

const heroHeadlineSubTabletSx = {
    display: "inline-block",
    [MEDIA_MAX_1023]: {
        ...heroHeadlineSubFontTabletSx,
    },
    [MEDIA_HEADLINE_NOWRAP]: {
        whiteSpace: "nowrap",
    },
    [MEDIA_MAX_599]: {
        display: "inline",
        whiteSpace: "normal",
        ...heroHeadlineSubFontMobile599Sx,
    },
};

const heroHeadlineMainFontMobile760To600Sx = {
    fontSize: `clamp(38px, calc(38px + (100vw - ${HERO_MOBILE_HEADLINE_MIN_VW}px) * 8 / ${HERO_MOBILE_HEADLINE_VW_RANGE}), 46px)`,
};

const heroHeadlineSubFontMobile760To600Sx = {
    fontSize: `clamp(36px, calc(36px + (100vw - ${HERO_MOBILE_HEADLINE_MIN_VW}px) * 10 / ${HERO_MOBILE_HEADLINE_VW_RANGE}), 46px)`,
};

const statsNumberFontMobile760To600Sx = {
    fontSize: `clamp(40px, calc(40px + (100vw - ${STATS_MOBILE_MIN_VW}px) * 4 / ${STATS_MOBILE_VW_RANGE}), 44px)`,
};

const statsCaptionFontMobile760To600Sx = {
    fontSize: `clamp(18px, calc(18px + (100vw - ${STATS_MOBILE_MIN_VW}px) * 4 / ${STATS_MOBILE_VW_RANGE}), 22px)`,
};

const buttonWidthDividerMobile400ButtonSx = {
    lineHeight: 1,
    [MEDIA_MAX_400]: {
        width: "auto",
        minWidth: "unset",
        px: "14px",
        height: 42,
        minHeight: 42,
        fontSize: "16px",
    },
};

const buttonWidthDividerMobile400DecorSx = {
    [MEDIA_MAX_400]: {
        '& .MuiDivider-root': {
            width: "44px",
        },
        '& .child-box': {
            width: "20px",
            height: "20px",
            right: "-10px",
        },
        '&:hover .child-box': {
            width: "32px",
            height: "32px",
            right: "-16px",
        },
    },
};

const buttonWidthDividerMobile500ButtonSx = {
    lineHeight: 1,
    [MEDIA_MAX_500]: {
        width: "auto",
        minWidth: "unset",
        px: "14px",
        height: 42,
        minHeight: 42,
        fontSize: "16px",
    },
};

const buttonWidthDividerMobile500DecorSx = {
    [MEDIA_MAX_500]: {
        '& .MuiDivider-root': {
            width: "44px",
        },
        '& .child-box': {
            width: "20px",
            height: "20px",
            right: "-10px",
        },
        '&:hover .child-box': {
            width: "32px",
            height: "32px",
            right: "-16px",
        },
    },
};

const KuhniVersoMebel = () => {
    const [hoverId, setHoverId] = useState(null)
    const [questionsOpenId, setQuestionsOpenId] = useState([])
    const navigate = useNavigate();
    const [alertData, setAlertData] = useState({});
    const [carouselOptionsCorner, setCarouselOptionsCorner] = useState({data: [], pageIndex: 0, totalElements: 0})
    const [carouselOptionsStraight, setCarouselOptionsStraight] = useState({data: [], pageIndex: 0, totalElements: 0})
    const [carouselStraightNextPage, setCarouselStraightNextPage] = useState([])
    const [carouselStraightPrevPage, setCarouselStraightPrevPage] = useState([])
    const [carouselCornerNextPage, setCarouselCornerNextPage] = useState([])
    const [carouselCornerPrevPage, setCarouselCornerPrevPage] = useState([])

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleNextStraight = () => {
        const pageCount = getKitchenCarouselPageCount(carouselOptionsStraight.totalElements);
        setCarouselOptionsStraight((prev) => ({
            ...prev,
            pageIndex: prev.pageIndex < pageCount - 1 ? prev.pageIndex + 1 : 0,
        }));
    };

    const handlePrevStraight = () => {
        const pageCount = getKitchenCarouselPageCount(carouselOptionsStraight.totalElements);
        setCarouselOptionsStraight((prev) => ({
            ...prev,
            pageIndex: prev.pageIndex > 0 ? prev.pageIndex - 1 : pageCount - 1,
        }));
    };

    const handleNextCorner = () => {
        const pageCount = getKitchenCarouselPageCount(carouselOptionsCorner.totalElements);
        setCarouselOptionsCorner((prev) => ({
            ...prev,
            pageIndex: prev.pageIndex < pageCount - 1 ? prev.pageIndex + 1 : 0,
        }));
    };

    const handlePrevCorner = () => {
        const pageCount = getKitchenCarouselPageCount(carouselOptionsCorner.totalElements);
        setCarouselOptionsCorner((prev) => ({
            ...prev,
            pageIndex: prev.pageIndex > 0 ? prev.pageIndex - 1 : pageCount - 1,
        }));
    };

    useEffect(() => {
        let cancelled = false;
        const pageIndex = carouselOptionsStraight.pageIndex;

        fetchKitchenCarouselCards("STRAIGHT", pageIndex)
            .then(function ({content, totalElements}) {
                if (cancelled) {
                    return;
                }
                setCarouselOptionsStraight((prev) => ({
                    ...prev,
                    data: content,
                    totalElements,
                }));
            })
            .catch(function (error) {
                if (!cancelled) {
                    handleModalAlert(error);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [carouselOptionsStraight.pageIndex])

    useEffect(() => {
        let cancelled = false;
        const pageIndex = carouselOptionsCorner.pageIndex;

        fetchKitchenCarouselCards("CORNER", pageIndex)
            .then(function ({content, totalElements}) {
                if (cancelled) {
                    return;
                }
                setCarouselOptionsCorner((prev) => ({
                    ...prev,
                    data: content,
                    totalElements,
                }));
            })
            .catch(function (error) {
                if (!cancelled) {
                    handleModalAlert(error);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [carouselOptionsCorner.pageIndex])

    useEffect(() => {
        let cancelled = false;
        const {pageIndex, totalElements} = carouselOptionsStraight;
        const pageCount = getKitchenCarouselPageCount(totalElements);
        const nextPageIndex = pageIndex < pageCount - 1 ? pageIndex + 1 : pageCount > 1 ? 0 : -1;
        const prevPageIndex = pageIndex > 0 ? pageIndex - 1 : pageCount > 1 ? pageCount - 1 : -1;

        if (nextPageIndex < 0) {
            setCarouselStraightNextPage([]);
        } else {
            fetchKitchenCarouselCards("STRAIGHT", nextPageIndex)
                .then(({content}) => {
                    if (!cancelled) {
                        setCarouselStraightNextPage(content);
                    }
                })
                .catch(() => {
                    if (!cancelled) {
                        setCarouselStraightNextPage([]);
                    }
                });
        }

        if (prevPageIndex < 0) {
            setCarouselStraightPrevPage([]);
        } else {
            fetchKitchenCarouselCards("STRAIGHT", prevPageIndex)
                .then(({content}) => {
                    if (!cancelled) {
                        setCarouselStraightPrevPage(content);
                    }
                })
                .catch(() => {
                    if (!cancelled) {
                        setCarouselStraightPrevPage([]);
                    }
                });
        }

        return () => {
            cancelled = true;
        };
    }, [carouselOptionsStraight.pageIndex, carouselOptionsStraight.totalElements]);

    useEffect(() => {
        let cancelled = false;
        const {pageIndex, totalElements} = carouselOptionsCorner;
        const pageCount = getKitchenCarouselPageCount(totalElements);
        const nextPageIndex = pageIndex < pageCount - 1 ? pageIndex + 1 : pageCount > 1 ? 0 : -1;
        const prevPageIndex = pageIndex > 0 ? pageIndex - 1 : pageCount > 1 ? pageCount - 1 : -1;

        if (nextPageIndex < 0) {
            setCarouselCornerNextPage([]);
        } else {
            fetchKitchenCarouselCards("CORNER", nextPageIndex)
                .then(({content}) => {
                    if (!cancelled) {
                        setCarouselCornerNextPage(content);
                    }
                })
                .catch(() => {
                    if (!cancelled) {
                        setCarouselCornerNextPage([]);
                    }
                });
        }

        if (prevPageIndex < 0) {
            setCarouselCornerPrevPage([]);
        } else {
            fetchKitchenCarouselCards("CORNER", prevPageIndex)
                .then(({content}) => {
                    if (!cancelled) {
                        setCarouselCornerPrevPage(content);
                    }
                })
                .catch(() => {
                    if (!cancelled) {
                        setCarouselCornerPrevPage([]);
                    }
                });
        }

        return () => {
            cancelled = true;
        };
    }, [carouselOptionsCorner.pageIndex, carouselOptionsCorner.totalElements]);

    const handleQuesion = (id) => {
        const isAdd = !questionsOpenId.includes(id)
        if (isAdd) {
            setQuestionsOpenId(prevState => [...prevState, id])
        } else {
            const newData = questionsOpenId.filter(el => el !== id)
            setQuestionsOpenId(newData)
        }
    }

    const renderStatText = (text) => {
        const phrase = 'с 2002 года';
        if (!text.includes(phrase)) return text;
        const [before, after] = text.split(phrase);
        return (
            <>
                {before}
                <Box component="span" sx={{whiteSpace: 'nowrap'}}>{phrase}</Box>
                {after}
            </>
        );
    };

    return <>
        <Box sx={{
            display: 'flex',
            flexDirection: "column",
            alignItems: "center",
            gridGap: "160px",
            width: "100%",
            overflow: "hidden",
            '@media (max-width: 1450px)': {
                gridGap: "140px",
            },
            '@media (max-width: 1023px)': {
                gridGap: "110px",
                width: "100%",
                maxWidth: "900px",
                marginLeft: "auto",
                marginRight: "auto",
                boxSizing: "border-box",
            },
            [MEDIA_MAX_599]: {
                gridGap: "60px",
            },
        }}>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
            }}>
            <Box sx={{
                display: 'flex',
                alignItems: "center",
                boxSizing: "border-box",
                justifyContent: "space-between",
                backgroundColor: (theme) => theme.palette.background.grey,
                borderRadius: "16px",
                padding: "40px",
                gap: "40px",
                width: "100%",
                containerType: "inline-size",
                containerName: "hero",
                '@media (max-width: 1450px)': {
                    padding: "20px",
                    gap: "24px",
                },
                '@media (max-width: 1620px)': {
                    flexDirection: "row",
                    alignItems: "center",
                },
                '@media (max-width: 1023px)': {
                    flexDirection: "column",
                    alignItems: "stretch",
                    gap: "40px",
                    padding: "40px",
                },
                '@media (max-width: 834px)': {
                    padding: "30px",
                },
                [MEDIA_MAX_760]: {
                    padding: "20px",
                },
                [MEDIA_MAX_599]: {
                    width: "auto",
                },
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: "column",
                    width: "720px",
                    gap: "40px",
                    boxSizing: "border-box",
                    containerType: "inline-size",
                    '@media (max-width: 1620px)': {
                        width: "calc(50% - 20px)",
                        flex: "0 0 calc(50% - 20px)",
                        minWidth: 0,
                    },
                    '@media (max-width: 1450px)': {
                        width: "auto",
                        flex: "1 1 0",
                        minWidth: 0,
                        gap: "24px",
                    },
                    '@media (max-width: 1023px)': {
                        width: "100%",
                        flex: "0 0 auto",
                        gap: "24px",
                        containerType: "normal",
                    },
                }}>
                    <Box sx={{
                        display: 'flex', gap: "20px",
                        alignItems: "stretch",
                        '@media (max-width: 1450px)': {
                            gap: "12px",
                        },
                        '@media (max-width: 1200px)': {
                            flexWrap: "wrap",
                            width: "fit-content",
                            maxWidth: "100%",
                        },
                        '@media (max-width: 1023px)': {
                            flexWrap: "nowrap",
                            width: "100%",
                            gap: "24px",
                        },
                        [MEDIA_MAX_400]: {
                            ...heroBadgesRowMobile400Sx,
                        },
                    }}>
                        <Box sx={{
                            boxSizing: "border-box",
                            width: 265,
                            height: "100%",
                            backgroundColor: `rgba(245, 246, 250, 1)`,
                            boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16);`,
                            borderRadius: "12px",
                            padding: "6px 12px",
                            '@media (max-width: 1200px)': {
                                width: "fit-content",
                                maxWidth: 180,
                                flex: "0 0 auto",
                                height: "auto",
                                padding: "4px 10px",
                            },
                            '@media (max-width: 1023px)': {
                                width: 265,
                                maxWidth: "none",
                                flex: "unset",
                                height: 52,
                                minHeight: "unset",
                                padding: "6px 12px",
                            },
                            [MEDIA_MAX_599]: {
                                ...heroBadgeBoxMobile599Sx,
                            },
                            [MEDIA_MAX_400]: {
                                height: "auto",
                            },
                        }}>
                            <Typography sx={{
                                fontSize: "16px", fontWeight: 400, lineHeight: 1.2,
                                maxWidth: "265px",
                                '@media (max-width: 1200px)': {
                                    fontSize: "13px",
                                    whiteSpace: "normal",
                                    '& br': {display: 'none'},
                                },
                                '@media (max-width: 1023px)': {
                                    fontSize: "16px",
                                    whiteSpace: "normal",
                                    '& br': {display: "inline"},
                                },
                                [MEDIA_MAX_599]: {
                                    '& br': {display: 'none'},
                                },
                                [MEDIA_MAX_400]: {
                                    maxWidth: "200px",
                                },
                            }}>
                                Гибкость <br/> как у индивидуального заказа
                            </Typography>
                        </Box>
                        <Box sx={{
                            boxSizing: "border-box",
                            width: 194,
                            height: "100%",
                            backgroundColor: `rgba(245, 246, 250, 1)`,
                            boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16);`,
                            borderRadius: "12px",
                            padding: "6px 12px",
                            '@media (max-width: 1200px)': {
                                width: "fit-content",
                                maxWidth: 140,
                                flex: "0 0 auto",
                                height: "auto",
                                padding: "4px 10px",
                            },
                            '@media (max-width: 1023px)': {
                                width: 194,
                                maxWidth: "none",
                                flex: "unset",
                                height: 52,
                                minHeight: "unset",
                                padding: "6px 12px",
                            },
                            [MEDIA_MAX_599]: {
                                ...heroBadgeBoxMobile599Sx,
                            },
                            [MEDIA_MAX_400]: {
                                height: "auto",
                            },
                        }}>
                            <Typography sx={{
                                fontSize: "16px", fontWeight: 400, lineHeight: 1.2,
                                maxWidth: "195px",
                                '@media (max-width: 1200px)': {
                                    fontSize: "13px",
                                    whiteSpace: "normal",
                                },
                                '@media (max-width: 1023px)': {
                                    fontSize: "16px",
                                },
                                [MEDIA_MAX_400]: {
                                    maxWidth: "100%",
                                },
                            }}>
                                Цена как у серийной мебели
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: "58px",
                                fontWeight: 800,
                                lineHeight: 1.2,
                                textTransform: "uppercase",
                                color: (theme) => theme.palette.secondary.add,
                                '@media (max-width: 1450px)': {
                                    fontSize: "clamp(36px, 8.056cqw, 58px)",
                                },
                                ...heroHeadlineMainTabletSx,
                                [MEDIA_MAX_760]: {
                                    ...heroHeadlineMainFontMobile760To600Sx,
                                },
                                [MEDIA_MAX_599]: {
                                    ...heroHeadlineMainWordMobile599Sx,
                                    ...heroHeadlineMainFontMobile599Sx,
                                },
                            }}
                        >
                            Индивидуальная
                        </Typography>
                        <Typography
                            component="span"
                            sx={{
                                fontSize: "58px",
                                fontWeight: 800,
                                lineHeight: 1.2,
                                textTransform: "uppercase",
                                '@media (max-width: 1450px)': {
                                    fontSize: "clamp(36px, 8.056cqw, 58px)",
                                },
                                ...heroHeadlineKitchenTabletSx,
                                [MEDIA_MAX_760]: {
                                    ...heroHeadlineMainFontMobile760To600Sx,
                                },
                                [MEDIA_MAX_599]: {
                                    ...heroHeadlineKitchenWordMobile599Sx,
                                    ...heroHeadlineMainFontMobile599Sx,
                                },
                            }}
                        >
                            кухня
                        </Typography>
                        <Typography
                            component="span"
                            sx={{
                                fontSize: "50px",
                                fontWeight: 800,
                                lineHeight: 1.2,
                                textTransform: "uppercase",
                                '@media (max-width: 1450px)': {
                                    fontSize: "clamp(32px, 6.944cqw, 50px)",
                                },
                                ...heroHeadlineSubTabletSx,
                                [MEDIA_MAX_760]: {
                                    ...heroHeadlineSubFontMobile760To600Sx,
                                },
                                [MEDIA_MAX_599]: {
                                    display: "inline",
                                    whiteSpace: "normal",
                                    ...heroHeadlineSubFontMobile599Sx,
                                },
                            }}
                        >
                        по&nbsp;цене стандартной
                        </Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: "20px",
                        '@media (max-width: 1620px)': {
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "16px",
                        },
                        '@media (max-width: 1450px)': {
                            gap: "12px",
                        },
                        [MEDIA_MAX_1023]: {
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "24px",
                        },
                    }}>
                        <Typography sx={{
                            width: "247px", fontSize: "17px", fontWeight: 600, lineHeight: 1.2,
                            '@media (max-width: 1620px)': {
                                width: "100%",
                            },
                            [MEDIA_MAX_1023]: {
                                width: "100%",
                                '& br': {display: 'none'},
                            },
                        }}>
                            Индивидуальный проект <br/> на основе готового шаблона от производителя.
                        </Typography>
                        <ButtonWidthDivider
                            onClick={() => navigate('/catalog')}
                            text={"Подобрать шаблон"}
                            width={276}
                            buttonSx={{
                                '@media (max-width: 1200px)': {
                                    width: "auto",
                                    minWidth: "unset",
                                    py: "8px",
                                    px: "18px",
                                    height: 48,
                                    minHeight: 48,
                                    fontSize: "19px",
                                },
                                [MEDIA_MAX_1023]: {
                                    width: 276,
                                    minWidth: 276,
                                    height: 56,
                                    minHeight: 56,
                                    py: "unset",
                                    px: "unset",
                                    fontSize: "22px",
                                },
                                [MEDIA_MAX_599]: {
                                    width: 220,
                                    minWidth: 220,
                                    height: 48,
                                    minHeight: 48,
                                    fontSize: "19px",
                                },
                                [MEDIA_MAX_400]: {
                                    width: "auto",
                                    minWidth: "unset",
                                    px: "14px",
                                    height: 42,
                                    minHeight: 42,
                                    fontSize: "16px",
                                },
                            }}
                            sx={{
                                '@media (max-width: 1200px)': {
                                    '& .MuiDivider-root': {
                                        width: "64px",
                                    },
                                    '& .child-box': {
                                        width: "24px",
                                        height: "24px",
                                        right: "-12px",
                                    },
                                    '&:hover .child-box': {
                                        width: "40px",
                                        height: "40px",
                                        right: "-20px",
                                    },
                                },
                                [MEDIA_MAX_1023]: {
                                    '& .MuiDivider-root': {
                                        width: "80px",
                                    },
                                    '& .child-box': {
                                        width: "28px",
                                        height: "28px",
                                        right: "-15px",
                                    },
                                    '&:hover .child-box': {
                                        width: "50px",
                                        height: "50px",
                                        right: "-25px",
                                    },
                                },
                                [MEDIA_MAX_599]: {
                                    '& .MuiDivider-root': {
                                        width: "56px",
                                    },
                                    '& .child-box': {
                                        width: "24px",
                                        height: "24px",
                                        right: "-12px",
                                    },
                                    '&:hover .child-box': {
                                        width: "40px",
                                        height: "40px",
                                        right: "-20px",
                                    },
                                },
                                [MEDIA_MAX_400]: {
                                    '& .MuiDivider-root': {
                                        width: "44px",
                                    },
                                    '& .child-box': {
                                        width: "20px",
                                        height: "20px",
                                        right: "-10px",
                                    },
                                    '&:hover .child-box': {
                                        width: "32px",
                                        height: "32px",
                                        right: "-16px",
                                    },
                                },
                            }}
                        />
                    </Box>
                </Box>
                <Box sx={{
                    width: "760px",
                    maxWidth: "100%",
                    height: "auto",
                    aspectRatio: "760 / 700",
                    flexShrink: 0,
                    boxSizing: "border-box",
                    backgroundColor: "grey",
                    borderRadius: "16px",
                    backgroundImage: `url(${kitchenMain})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    '@media (max-width: 1620px)': {
                        width: "calc(50% - 20px)",
                        flex: "0 0 calc(50% - 20px)",
                        minWidth: 0,
                    },
                    '@media (max-width: 1450px)': {
                        width: "clamp(280px, 48cqw, 760px)",
                        flex: "0 1 auto",
                        aspectRatio: "760 / 700",
                        height: "auto",
                    },
                    '@media (max-width: 1023px)': {
                        width: "100%",
                        height: "auto",
                        flex: "0 0 auto",
                        minWidth: 0,
                        aspectRatio: "760 / 700",
                        maxWidth: "100%",
                    },
                }}/>

            </Box>
            <Box sx={{
                display: "flex",
                gap: "20px",
                flexWrap: "nowrap",
                width: "100%",
                containerType: "inline-size",
                [MEDIA_MAX_599]: {
                    flexDirection: "column",
                    padding: "0 16px",
                    boxSizing: "border-box",
                },
            }}>
                {stats.map((el) => {
                    return <Box key={el.id} sx={{
                        boxSizing: "border-box",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: "column",
                        gap: "28px",
                        padding: "28px 8px",
                        backgroundColor: (theme) => theme.palette.background.grey,
                        width: "calc((100% - 40px) / 3)",
                        flex: "1 1 calc((100% - 40px) / 3)",
                        borderRadius: "8px",
                        [MEDIA_MAX_760]: {
                            gap: "16px",
                            padding: "18px 6px",
                        },
                        [MEDIA_MAX_599]: {
                            width: "100%",
                            flex: "1 1 auto",
                        },
                    }}>
                        <Typography sx={{
                            fontSize: "68px",
                            fontWeight: 900,
                            lineHeight: 0.75,
                            textAlign: "center",
                            '@media (max-width: 1450px)': {
                                fontSize: "clamp(44px, 4.722cqw, 68px)",
                            },
                            [MEDIA_MAX_1023]: {
                                fontSize: "44px",
                            },
                            [MEDIA_MAX_760]: {
                                ...statsNumberFontMobile760To600Sx,
                            },
                            [MEDIA_MAX_599]: {
                                fontSize: "44px",
                            },
                        }}>
                            {el.header}
                        </Typography>
                        <Typography sx={{
                            fontSize: "22px",
                            fontWeight: 600,
                            lineHeight: 1,
                            textAlign: "center",
                            [MEDIA_MAX_760]: {
                                ...statsCaptionFontMobile760To600Sx,
                            },
                            [MEDIA_MAX_599]: {
                                fontSize: "22px",
                            },
                        }}>
                            {renderStatText(el.text)}
                        </Typography>
                    </Box>
                })}
            </Box>
            </Box>
            <Box sx={{
                position: "relative",
                width: "100%",
                alignSelf: "stretch",
                [MEDIA_MAX_1023]: {
                    paddingBottom: "max(calc(40px + 53vw), 232px)",
                    boxSizing: "border-box",
                },
                [MEDIA_MAX_599]: {
                    padding: "16px",
                    paddingBottom: "max(calc(40px + 53vw), 232px)",
                    boxSizing: "border-box",
                },
            }}>
                <Box sx={{
                    position: "static",
                    boxSizing: "border-box",
                    backgroundColor: (theme) => theme.palette.background.grey,
                    borderRadius: "16px",
                    paddingTop: "60px",
                    paddingBottom: "60px",
                    paddingLeft: "40px",
                    paddingRight: "9%",
                    width: "max(500px, 41%)",
                    minHeight: "min(40vw, 650px)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    zIndex: 1,
                    '& > .MuiTypography-root': {
                        width: "100%",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                    },
                    '& > .MuiTypography-root:not(:first-of-type):not(:last-of-type)': {
                        paddingRight: "40px",
                    },
                    '@media (max-width: 1620px)': {
                        paddingTop: "clamp(30px, 3.704vw, 60px)",
                        paddingBottom: "clamp(30px, 3.704vw, 60px)",
                        paddingLeft: "clamp(20px, 2.469vw, 40px)",
                    },
                    '@media (max-width: 1500px)': {
                        padding: "30px 20px",
                        paddingRight: "9%",
                        '& > .MuiTypography-root:not(:first-of-type):not(:last-of-type)': {
                            paddingRight: "30px",
                        },
                    },
                    [MEDIA_MAX_1023]: {
                        width: "100%",
                        maxWidth: "100%",
                        minHeight: "unset",
                        padding: "40px",
                        '& > .MuiTypography-root:not(:first-of-type):not(:last-of-type)': {
                            paddingRight: 0,
                        },
                        '& > .MuiTypography-root:first-of-type': {
                            marginBottom: "40px",
                        },
                        '& > .MuiTypography-root:nth-of-type(n+3)': {
                            marginTop: "12px",
                        },
                    },
                    [MEDIA_MAX_599]: {
                        padding: "16px",
                    },
                }}>
                    <Typography sx={{
                        fontSize: "40px",
                        fontWeight: 600,
                        lineHeight: 1.2,
                        textTransform: "uppercase",
                        marginBottom: "40px",
                        '@media (max-width: 1620px)': {
                            fontSize: "clamp(28px, calc(28px + (100vw - 1500px) * 12 / 120), 40px)",
                        },
                        '@media (max-width: 1500px)': {
                            marginBottom: "20px",
                        },
                        '@media (max-width: 1200px)': {
                            fontSize: "26px",
                            marginBottom: "16px",
                        },
                        [MEDIA_MAX_1023]: {
                            fontSize: "40px",
                            marginBottom: 0,
                        },
                        ...blockHeadingMobileSx,
                        [MEDIA_MAX_599]: {
                            fontSize: "24px",
                            marginBottom: "20px",
                        },
                    }}>
                        Почему с <span style={{color: "#3B8BEC"}}>2002 года </span>{' '}
                        <Box component="span" sx={{whiteSpace: "nowrap"}}>
                            вы <span style={{color: "#3B8BEC"}}>выбираете</span> нас?
                        </Box>
                    </Typography>
                    <Typography sx={{
                        fontSize: 17,
                        lineHeight: 1.3,
                        '@media (max-width: 1500px)': {
                            fontSize: 16,
                            lineHeight: 1.2,
                        },
                        '@media (max-width: 1200px)': {
                            fontSize: 15,
                        },
                        [MEDIA_MAX_1023]: {
                            fontSize: 17,
                            lineHeight: 1.3,
                        },
                    }}>
                        Мы начали свой путь в 2002 году с небольшого столярного цеха. За почти 25 лет мы выросли в
                        масштабное высокотехнологичное производство, сохранив при этом внимательное отношение к каждой
                        детали.
                    </Typography>
                    <Typography sx={{
                        marginTop: "12px",
                        textWrap: "wrap",
                        fontSize: 17,
                        lineHeight: 1.3,
                        '@media (max-width: 1500px)': {
                            fontSize: 16,
                            lineHeight: 1.2,
                        },
                        '@media (max-width: 1200px)': {
                            fontSize: 15,
                            marginTop: "10px",
                        },
                        [MEDIA_MAX_1023]: {
                            fontSize: 17,
                            lineHeight: 1.3,
                        },
                    }}>
                        Все детали проходят через автоматизированные центры обработки. Это исключает «человеческий
                        фактор» — никаких кривых стыков или несовпадающих отверстий.
                    </Typography>
                    <Typography sx={{
                        marginTop: "12px",
                        textWrap: "wrap",
                        fontSize: 17,
                        lineHeight: 1.3,
                        '@media (max-width: 1500px)': {
                            fontSize: 16,
                            lineHeight: 1.2,
                        },
                        '@media (max-width: 1200px)': {
                            fontSize: 15,
                            marginTop: "10px",
                        },
                        [MEDIA_MAX_1023]: {
                            fontSize: 17,
                            lineHeight: 1.3,
                        },
                    }}>
                        Мы знаем о кухнях всё: как сделать их удобными, долговечными и при этом сохранить честную цену
                        от производителя.
                    </Typography>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    top: "50%",
                    left: "max(32%, 400px)",
                    transform: "translateY(-50%)",
                    width: "37.5%",
                    aspectRatio: "1",
                    zIndex: 1,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: 'calc(100% / 0.91846)',
                        aspectRatio: '1',
                        transform: 'translate(-50%, -50%)',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        zIndex: 0,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        backgroundImage: `url(${kitchen2})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16)`,
                        zIndex: 1,
                    },
                    [MEDIA_MAX_1023]: {
                        top: "auto",
                        bottom: "20px",
                        left: "20px",
                        right: "auto",
                        transform: "none",
                        width: "53vw",
                        '&::before': {
                            display: "none",
                        },
                    },
                    [MEDIA_MAX_599]: {
                        left: "16px",
                        right: "auto",
                    },
                }}/>
                <Box sx={{
                    position: 'absolute',
                    top: "50%",
                    right: 0,
                    transform: "translateY(-50%)",
                    width: "37.5%",
                    aspectRatio: "1",
                    zIndex: 2,
                    backgroundColor: "white",
                    borderRadius: "50%",
                    backgroundImage: `url(${kitchen3})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16);`,
                    [MEDIA_MAX_1023]: {
                        top: "auto",
                        bottom: "20px",
                        left: "auto",
                        right: "20px",
                        transform: "none",
                        width: "53vw",
                    },
                    [MEDIA_MAX_599]: {
                        left: "auto",
                        right: "16px",
                    },
                }}/>
            </Box>
        <Box sx={{
            display: 'flex',
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            boxSizing: "border-box",
            borderRadius: "16px",
            padding: "0 40px",
            gap: "40px",
            width: "100%",
            height: "1745px",
            '& .MuiTypography-root': {
                lineHeight: 1.3,
            },
            '@media (max-width: 1620px)': {
                flexDirection: "column",
            },
            '@media (max-width: 1200px)': {
                '& .MuiTypography-root': {
                    lineHeight: 1.2,
                },
            },
            [MEDIA_MAX_1023]: {
                height: "auto",
                paddingLeft: 0,
                paddingRight: 0,
                '& .MuiTypography-root': {
                    lineHeight: 1.3,
                },
            },
            [MEDIA_MAX_599]: {
                padding: "0 16px",
            },
        }}>
            <Typography sx={{
                fontSize: "40px", fontWeight: 600, textTransform: "uppercase",
                lineHeight: 1.2,
                textAlign: "center",
                padding: "0 20px",
                '@media (max-width: 1450px)': {
                    fontSize: "28px",
                },
                [MEDIA_MAX_1023]: {
                    fontSize: "40px",
                    textAlign: "center",
                },
                ...blockHeadingMobileSx,
                [MEDIA_MAX_599]: {
                    fontSize: "24px",
                    textAlign: "center",
                    padding: "0 20px",
                },
            }}>
                Как <span style={{color: "#3B8BEC"}}>работает</span> сервис заказа мебели UpMe
            </Typography>
            <Box sx={{
                height: "1630px", width: "1060px", position: "relative", display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                alignItems: "center",
                [MEDIA_MAX_1023]: {
                    width: "100%",
                    height: "auto",
                    gap: "80px",
                    alignItems: "flex-start",
                },
                [MEDIA_MAX_599]: {
                    gap: "20px",
                },
            }}>
                <Divider
                    orientation="vertical"
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: 0,
                        height: "100%",
                        transform: "translateX(-50%)",
                        borderColor: (theme) => theme.palette.primary.main,
                        zIndex: 0,
                        [MEDIA_MAX_1023]: {
                            left: stepTabletLineLeft,
                            transform: "translateX(-50%)",
                        },
                        [MEDIA_MAX_760]: {
                            left: stepMobileLineLeft,
                        },
                        [MEDIA_MAX_599]: {
                            left: stepMobileLineLeftNoPad,
                            transform: "translateX(-50%)",
                            display: "none",
                        },
                    }}
                />
                <Box sx={{
                    boxSizing: "border-box",
                    width: "790px",
                    bgcolor: (theme) => theme.palette.primary.lightGrey,
                    boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16)`,
                    borderRadius: "16px",
                    padding: "20px",
                    gap: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                    '@media (max-width: 1200px)': {
                        padding: "14px",
                        gap: "14px",
                    },
                    [MEDIA_MAX_1023]: {
                        width: "100%",
                        padding: "20px 16px",
                        gap: "20px",
                    },
                }}>
                    <Typography
                        sx={{
                            fontSize: "28px",
                            fontWeight: 700,
                            textAlign: "center",
                            [MEDIA_MAX_599]: {
                                fontSize: "22px",
                            },
                        }}>Всё просто: вы редактируете кухонный шаблон под свои размеры.</Typography>
                    <Typography
                        sx={{
                            fontSize: "17px",
                            fontWeight: 400,
                            width: "700px",
                            textAlign: "center",
                            [MEDIA_MAX_1023]: {
                                width: "100%",
                            },
                        }}>Наш конструктор — это шаблон кухни с набором готовых модулей (шкафов). Вы сами решаете, какой размер им задать. Система автоматически следит за размером кухни и совместимостью шкафов.</Typography>
                </Box>

                {stages.map((el, i) => {
                    const number = i + 1
                    return <Box key={el.id} sx={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        width: "100%",
                        flexDirection: number % 2 === 0 ? "row-reverse" : "row",
                        '@media (max-width: 1200px)': {
                            display: "grid",
                            gridTemplateColumns: "1fr auto 1fr",
                            alignItems: "center",
                            gap: "14px",
                        },
                        [MEDIA_MAX_1023]: {
                            display: "grid",
                            gridTemplateColumns: `${STEP_TABLET_CIRCLE}px 1fr`,
                            alignItems: "center",
                            columnGap: `${STEP_TABLET_GAP}px`,
                            paddingLeft: `${STEP_TABLET_STEP_PAD}px`,
                            paddingRight: `${STEP_TABLET_STEP_PAD}px`,
                            boxSizing: "border-box",
                            flexDirection: "unset",
                            position: "relative",
                            zIndex: 1,
                        },
                        [MEDIA_MAX_760]: {
                            width: "fit-content",
                            maxWidth: "100%",
                            marginLeft: "auto",
                            marginRight: "auto",
                            paddingLeft: 0,
                            paddingRight: 0,
                            gridTemplateColumns: `${STEP_MOBILE_CIRCLE}px minmax(0, ${STEP_CARD_WIDTH}px)`,
                            columnGap: `${STEP_MOBILE_GAP}px`,
                        },
                        [MEDIA_MAX_599]: {
                            display: "flex",
                            flexDirection: "column-reverse",
                            alignItems: "center",
                            gap: "20px",
                            width: "100%",
                            maxWidth: "100%",
                            marginLeft: 0,
                            marginRight: 0,
                            paddingLeft: 0,
                            paddingRight: 0,
                        },
                    }}>

                        <Box
                            onMouseEnter={() => el.img && setHoverId(number)}
                            onMouseLeave={() => setHoverId(null)}
                            sx={{
                                boxSizing: "border-box",
                                display: "flex",
                                flexDirection: "column",
                                width: "473px",
                                bgcolor: (theme) => theme.palette.primary.lightGrey,
                                border: hoverId === number ? (theme) => `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
                                boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16)`,
                                borderRadius: "16px",
                                padding: "20px",
                                gap: "10px",
                                position: "relative",
                                '@media (max-width: 1200px)': {
                                    gridColumn: number % 2 === 0 ? 3 : 1,
                                    justifySelf: number % 2 === 0 ? "start" : "end",
                                    width: "400px",
                                    padding: "14px",
                                    gap: "8px",
                                },
                                [MEDIA_MAX_1023]: {
                                    gridColumn: 2,
                                    gridRow: 1,
                                    width: "100%",
                                    justifySelf: "stretch",
                                    padding: "20px",
                                    gap: "10px",
                                },
                                [MEDIA_MAX_760]: {
                                    width: "100%",
                                    maxWidth: `${STEP_CARD_WIDTH}px`,
                                    padding: "14px",
                                    gap: "8px",
                                },
                                [MEDIA_MAX_599]: {
                                    width: "100%",
                                    maxWidth: "100%",
                                    gridColumn: "unset",
                                    gridRow: "unset",
                                    justifySelf: "stretch",
                                    padding: "16px",
                                    gap: "8px",
                                },
                            }}>
                            {(hoverId === number) &&
                                <Box sx={{
                                    height: '200px',
                                    minWidth: "250px",
                                    borderRadius: "8px",
                                    backgroundImage: `url(${el.img})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                    position: "absolute",
                                    transform: number > 2 ? `rotate(-10deg)` : `rotate(10deg)`,
                                    ...stepHoverImagePosition[number],
                                }}/>
                            }
                            <Typography
                                sx={{
                                    fontSize: "17px",
                                    fontWeight: 600,
                                    [MEDIA_MAX_599]: {
                                        fontSize: "16px",
                                    },
                                }}>{el.header}</Typography>
                            <Box sx={{
                                padding: "0 20px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                                '@media (max-width: 1200px)': {
                                    padding: "0 14px",
                                    gap: "8px",
                                },
                                [MEDIA_MAX_760]: {
                                    padding: "0 12px",
                                    gap: "6px",
                                },
                                [MEDIA_MAX_599]: {
                                    padding: "0 16px",
                                    gap: "8px",
                                },
                            }}>
                                {el.text.map((item) => (
                                    <Typography key={item.id} component="li"
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: 400,
                                                    [MEDIA_MAX_760]: {
                                                        fontSize: "15px",
                                                    },
                                                    [MEDIA_MAX_599]: {
                                                        fontSize: "16px",
                                                    },
                                                }}>{item.text}</Typography>
                                ))}
                            </Box>

                        </Box>
                        <Box sx={{
                            width: "74px",
                            height: "74px",
                            borderRadius: "74px",
                            bgcolor: (theme) => theme.palette.primary.main,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            position: "relative",
                            zIndex: 1,
                            '@media (max-width: 1200px)': {
                                gridColumn: 2,
                                gridRow: 1,
                                width: "60px",
                                height: "60px",
                                borderRadius: "60px",
                            },
                            [MEDIA_MAX_1023]: {
                                gridColumn: 1,
                                gridRow: 1,
                                width: `${STEP_TABLET_CIRCLE}px`,
                                height: `${STEP_TABLET_CIRCLE}px`,
                                minWidth: `${STEP_TABLET_CIRCLE}px`,
                                minHeight: `${STEP_TABLET_CIRCLE}px`,
                                borderRadius: "50%",
                                justifySelf: "center",
                                position: "relative",
                                zIndex: 1,
                            },
                            [MEDIA_MAX_760]: {
                                width: `${STEP_MOBILE_CIRCLE}px`,
                                height: `${STEP_MOBILE_CIRCLE}px`,
                                minWidth: `${STEP_MOBILE_CIRCLE}px`,
                                minHeight: `${STEP_MOBILE_CIRCLE}px`,
                            },
                            [MEDIA_MAX_599]: {
                                width: "74px",
                                height: "74px",
                                minWidth: "74px",
                                minHeight: "74px",
                                alignSelf: "center",
                                gridColumn: "unset",
                                gridRow: "unset",
                                zIndex: -1,
                            },
                            ...(number > 1 ? {
                                "&::before": {
                                    content: '""',
                                    display: "none",
                                    position: "absolute",
                                    left: "50%",
                                    bottom: "100%",
                                    transform: "translateX(-50%)",
                                    width: "1px",
                                    height: "24px",
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                    [MEDIA_MAX_599]: {
                                        display: "block",
                                    },
                                },
                            } : {}),
                            ...(number <= stages.length ? {
                                "&::after": {
                                    content: '""',
                                    display: "none",
                                    position: "absolute",
                                    left: "50%",
                                    top: "100%",
                                    transform: "translateX(-50%)",
                                    width: "1px",
                                    height: "24px",
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                    [MEDIA_MAX_599]: {
                                        display: "block",
                                    },
                                },
                            } : {}),
                        }}>
                            <Typography
                                sx={{
                                    fontSize: "34px",
                                    fontWeight: 700,
                                    color: "white",
                                }}>{`0${number}`}</Typography>
                        </Box>
                    </Box>
                })}
                <ButtonWidthDivider
                    onClick={() => navigate('/catalog')}
                    text={"Подобрать шаблон"}
                    width={276}
                    buttonSx={buttonWidthDividerMobile400ButtonSx}
                    sx={buttonWidthDividerMobile400DecorSx}
                />
            </Box>

        </Box>
        <Box sx={{
            display: 'flex',
            justifyContent: "flex-start",
            flexDirection: "column",
            alignItems: "stretch",
            alignSelf: "stretch",
            boxSizing: "border-box",
            borderRadius: "16px",
            padding: 0,
            gap: "60px",
            width: "100%",
            '@media (max-width: 1620px)': {
                flexDirection: "column",
            },
            [MEDIA_MAX_599]: {
                padding: "0 16px",
                gap: "40px",
            },
        }}>
            <Typography sx={{
                fontSize: "40px", fontWeight: 600, textTransform: "uppercase",
                lineHeight: 1.2,
                alignSelf: "center",
                '@media (max-width: 1450px)': {
                    fontSize: "28px",
                },
                [MEDIA_MAX_1023]: {
                    fontSize: "40px",
                },
                ...blockHeadingMobileSx,
                [MEDIA_MAX_599]: {
                    fontSize: "24px",
                },
            }}>
                <span style={{color: "#3B8BEC"}}>Виды</span> кухонь
            </Typography>
            <Typography sx={{
                fontSize: "28px", fontWeight: 600, width: "790px", maxWidth: "100%", textAlign: "center", lineHeight: 1.2,
                alignSelf: "center",
                ...blockHeadingSubMobileSx,
                [MEDIA_MAX_599]: {
                    fontSize: "22px",
                },
            }}>
                Ваш первый шаг — определиться с категорией кухонного гарнитура, который вам подходит.
            </Typography>
            {carouselOptionsCorner.totalElements > 0 && carouselOptionsCorner.data.length > 0 &&
                <Box sx={kitchenCarouselSectionSx}>
                    <Box sx={{display: 'flex', flexDirection: "column", gap: "20px", alignItems: "center"}}>
                        <Typography sx={{
                            fontSize: "34px", fontWeight: 700, textAlign: "center", lineHeight: 1.2,
                            ...blockHeadingMobileSx,
                            [MEDIA_MAX_599]: {
                                fontSize: "22px",
                            },
                        }}>
                            Угловые
                        </Typography>
                        <Typography sx={{
                            fontSize: "17px", fontWeight: 400, textAlign: "center", lineHeight: 1.2,
                        }}>
                            Шкафы размещены под углом, имеется угловой модуль стандартного размера.
                        </Typography>
                    </Box>
                    <Box sx={kitchenCarouselWrapperSx}>
                        <KuhniKitchenCarousel
                            banners={carouselOptionsCorner.data}
                            adjacentNextBanners={carouselCornerNextPage}
                            adjacentPrevBanners={carouselCornerPrevPage}
                            onPageNext={handleNextCorner}
                            onPagePrev={handlePrevCorner}
                        />
                    </Box>
                    <Box sx={kitchenCarouselButtonSx}>
                        <ButtonWidthDivider
                            text={"Смотреть угловые кухни"}
                            width={324}
                            onClick={() => navigate('/catalog?type=CORNER')}
                            buttonSx={buttonWidthDividerMobile500ButtonSx}
                            sx={buttonWidthDividerMobile500DecorSx}
                        />
                    </Box>
                </Box>
            }

            {carouselOptionsStraight.totalElements > 0 && carouselOptionsStraight.data.length > 0 &&
                <Box sx={kitchenCarouselSectionSx}>
                    <Box sx={{display: 'flex', flexDirection: "column", gap: "20px", alignItems: "center"}}>
                        <Typography sx={{
                            fontSize: "34px", fontWeight: 700, textAlign: "center", lineHeight: 1.2,
                            ...blockHeadingMobileSx,
                            [MEDIA_MAX_599]: {
                                fontSize: "22px",
                            },
                        }}>
                            Прямые
                        </Typography>
                        <Typography sx={{
                            fontSize: "17px", fontWeight: 400, textAlign: "center", lineHeight: 1.2,
                        }}>
                            Все шкафы выстроены в один ряд и образуют прямую линию.
                        </Typography>
                    </Box>
                    <Box sx={kitchenCarouselWrapperSx}>
                        <KuhniKitchenCarousel
                            banners={carouselOptionsStraight.data}
                            adjacentNextBanners={carouselStraightNextPage}
                            adjacentPrevBanners={carouselStraightPrevPage}
                            onPageNext={handleNextStraight}
                            onPagePrev={handlePrevStraight}
                        />
                    </Box>
                    <Box sx={kitchenCarouselButtonSx}>
                        <ButtonWidthDivider
                            text={"Смотреть прямые кухни"} width={319}
                            onClick={() => navigate('/catalog?type=STRAIGHT')}
                            buttonSx={buttonWidthDividerMobile500ButtonSx}
                            sx={buttonWidthDividerMobile500DecorSx}
                        />
                    </Box>
                </Box>}
        </Box>
        <Box sx={{
            display: 'flex',
            boxSizing: "border-box",
            backgroundColor: (theme) => theme.palette.background.grey,
            borderRadius: "16px",
            padding: "100px 20px",
            gap: "40px",
            alignItems: "center",
            width: "100%",
            position: 'relative',
            flexDirection: "column",
            '@media (max-width: 1450px)': {
                padding: "60px 20px",
            },
            [MEDIA_MAX_1023]: {
                paddingTop: "110px",
                paddingBottom: "110px",
                paddingLeft: "16px",
                paddingRight: "16px",
            },
            [MEDIA_MAX_599]: {
                padding: "40px 0",
            },
        }}>
            <Typography sx={{
                fontSize: "40px", fontWeight: 600, textTransform: "uppercase",
                lineHeight: 1.2,
                '@media (max-width: 1450px)': {
                    fontSize: "28px",
                },
                [MEDIA_MAX_1023]: {
                    fontSize: "40px",
                },
                ...blockHeadingMobileSx,
                [MEDIA_MAX_599]: {
                    fontSize: "24px",
                    padding: "0 16px",
                    textAlign: "center",
                },
            }}>
                Наши <span style={{color: "#3B8BEC"}}>преимущества</span>
            </Typography>
            <Box sx={{
                display: "flex",
                gap: "20px",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "nowrap",
                '@media (max-width: 1023px)': {
                    flexDirection: "column",
                    alignItems: "center",
                },
            }}>
                {advantages.map((el, i) => {
                    return <Box key={el.id} sx={{
                        boxSizing: "border-box",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "24px",
                        padding: "44px",
                        width: "min(calc((100% - 40px) / 3), 365px)",
                        flex: "0 0 auto",
                        height: "auto",
                        aspectRatio: "1 / 1",
                        alignSelf: "center",
                        borderRadius: "50%",
                        '@media (max-width: 1200px)': {
                            padding: "28px 48px 42px",
                            gap: "12px",
                            "& .MuiTypography-root": {
                                lineHeight: 1.2,
                                width: "100%",
                            },
                        },
                        '@media (max-width: 1023px)': {
                            width: "100%",
                            maxWidth: "365px",
                            flex: "none",
                            padding: "24px 44px 44px",
                            gap: "24px",
                            justifyContent: "center",
                            "& .MuiTypography-root": {
                                lineHeight: 1.2,
                                width: "auto",
                            },
                        },
                        [MEDIA_MAX_360]: {
                            gap: "10px",
                            paddingTop: "16px",
                        },
                        background: `linear-gradient(116.46deg, rgba(238, 246, 255, 0.33) 11.04%, rgba(145, 193, 252, 0.33) 88.43%)`,
                        backdropFilter: `blur(20.73px)`,
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            inset: 0,
                            borderRadius: 'inherit',
                            padding: '1px',
                            background: `linear-gradient(103.89deg, #FFFFFF 9.58%, #82E3FF 98.85%)`,
                            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                            WebkitMaskComposite: 'xor',
                            maskComposite: 'exclude',
                            pointerEvents: 'none',
                        }
                    }}>
                        <Typography sx={{
                            fontSize: "34px", fontWeight: 700, textAlign: "center", lineHeight: 1.2,
                            color: (theme) => theme.palette.primary.main,
                        }}>{`/${i + 1}`} </Typography>
                        <Typography sx={{
                            fontSize: "28px", fontWeight: 700, textAlign: "center", lineHeight: 1.2,
                            lineHeight: 1.3,
                        }}>{el.header} </Typography>
                        <Typography sx={{
                            fontSize: "16px", fontWeight: 400, textAlign: "center", lineHeight: 1.2,
                        }}>{el.text} </Typography>
                    </Box>
                })}
            </Box>
        </Box>
        {false && <Box sx={{
            display: 'flex',
            boxSizing: "border-box",
            borderRadius: "16px",
            gap: "60px",
            position: 'relative', flexDirection: "column"
        }}>
            <Typography sx={{
                fontSize: "40px", fontWeight: 600, textTransform: "uppercase",
                '@media (max-width: 1450px)': {
                    fontSize: "28px",
                }
            }}>
                <span style={{color: "#3B8BEC"}}>Новости</span> компании
            </Typography>
            <Box sx={{display: 'flex', justifyContent: "space-between"}}>
                {news?.map((el, i) => {
                    return <Box key={el.id} sx={{
                        gridArea: `news${i + 1}`
                    }}
                    >
                        <Card
                            picturePosition={"bottom"}
                            key={el.id}
                            element={el}
                            width={520}
                            height={400}
                            withBorder={true}
                            withTheme={false}
                            descriptionLine={3}
                            imgHeight={183}
                        />
                    </Box>
                })}
            </Box>
        </Box>}
        <Box sx={{
            display: 'flex',
            boxSizing: "border-box",
            backgroundColor: (theme) => theme.palette.background.grey,
            borderRadius: "16px",
            padding: "100px 50px",
            gap: "60px",
            width: "100%",
            position: 'relative',
            justifyContent: "space-between",
            alignItems: "flex-start",
            '@media (max-width: 1500px)': {
                padding: "60px 40px",
                gap: "48px",
            },
            '@media (max-width: 1450px)': {
                flexWrap: "nowrap",
                gap: "60px",
            },
            '@media (max-width: 1200px)': {
                padding: "60px 20px",
                gap: "20px",
            },
            '@media (max-width: 1023px)': {
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "flex-start",
                paddingTop: "110px",
                paddingBottom: "110px",
                paddingLeft: "16px",
                paddingRight: "16px",
            },
            [MEDIA_MAX_599]: {
                padding: "40px 20px",
            },
        }}>
            <Typography sx={{
                fontSize: "40px",
                fontWeight: 600,
                textTransform: "uppercase",
                lineHeight: 1.2,
                flex: "1 1 0",
                minWidth: 0,
                whiteSpace: "normal",
                overflowWrap: "break-word",
                '@media (max-width: 1450px)': {
                    fontSize: "32px",
                    flex: "0 0 auto",
                    width: "360px",
                    minWidth: "360px",
                    maxWidth: "360px",
                },
                '@media (max-width: 1200px)': {
                    fontSize: "28px",
                    width: "340px",
                    minWidth: "340px",
                    maxWidth: "340px",
                },
                [MEDIA_MAX_1023]: {
                    flex: "none",
                    width: "100%",
                    minWidth: 0,
                    maxWidth: "100%",
                    alignSelf: "stretch",
                    fontSize: "40px",
                },
                ...blockHeadingMobileSx,
            }}>
                Часто задаваемые <span style={{color: "#3B8BEC"}}>вопросы</span>
            </Typography>
            <Box sx={{
                display: 'flex',
                flexDirection: "column",
                gap: "10px",
                width: "740px",
                maxWidth: "100%",
                flexShrink: 0,
                '@media (max-width: 1450px)': {
                    flex: "1 1 0",
                    minWidth: 0,
                    width: "auto",
                    maxWidth: "740px",
                    gap: "8px",
                },
                '@media (max-width: 1200px)': {
                    gap: "6px",
                },
                '@media (max-width: 1023px)': {
                    width: "100%",
                    maxWidth: "100%",
                    flex: "1 1 auto",
                    alignSelf: "stretch",
                    minWidth: 0,
                },
            }}>
                {questions.map((el) => {
                    const isOpen = questionsOpenId.includes(el.id)
                    return <Box
                        key={el.id}
                        component="button"
                        onClick={() => handleQuesion(el.id)}
                        sx={{
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            gap: "4px",
                            boxSizing: "border-box",
                            backgroundColor: isOpen ? (theme) => theme.palette.primary.main : "white",
                            borderRadius: "16px",
                            borderBottom: isOpen ? '1px solid transparent' : (theme) => `1px solid ${theme.palette.primary.main}`,
                            color: isOpen ? "white" : (theme) => theme.palette.text.main,
                            width: "100%",
                            minHeight: "72px",
                            padding: "12px",
                            textAlign: "left",
                            transition: "background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease",
                            '@media (max-width: 1450px)': {
                                padding: "10px",
                                minHeight: "64px",
                            },
                            '@media (max-width: 1200px)': {
                                padding: "8px",
                                minHeight: "56px",
                            },
                        }}>
                        <Box sx={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            padding: "10px 0",
                            '@media (max-width: 1450px)': {
                                padding: "8px 0",
                            },
                            '@media (max-width: 1200px)': {
                                padding: "6px 0",
                            },
                        }}>
                            <Typography sx={{
                                fontSize: "24px", fontWeight: 600, lineHeight: 1.3,
                                '@media (max-width: 1450px)': {
                                    fontSize: "21px",
                                },
                                '@media (max-width: 1200px)': {
                                    fontSize: "19px",
                                },
                                [MEDIA_MAX_1023]: {
                                    fontSize: "24px",
                                },
                                [MEDIA_MAX_599]: {
                                    fontSize: "17px",
                                },
                            }}>{el.header} </Typography>
                            <Collapse in={isOpen} timeout={300} sx={{width: "100%"}}>
                                {el.content
                                    ? <FaqAnswerContent content={el.content}/>
                                    : el.text && (
                                        <Typography sx={{
                                            fontSize: "17px",
                                            fontWeight: 400,
                                            lineHeight: 1.2,
                                            textAlign: "start",
                                            pt: "10px",
                                            '@media (max-width: 1450px)': {
                                                fontSize: "16px",
                                                pt: "8px",
                                            },
                                            '@media (max-width: 1200px)': {
                                                fontSize: "15px",
                                                pt: "6px",
                                            },
                                            [MEDIA_MAX_1023]: {
                                                fontSize: "17px",
                                                pt: "10px",
                                            },
                                        }}>{el.text}</Typography>
                                    )}
                            </Collapse>
                        </Box>
                        <Box
                            sx={{
                                width: "48px",
                                height: "48px",
                                flexShrink: 0,
                                marginLeft: "auto",
                                borderRadius: "50%",
                                backgroundColor: isOpen ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.main,
                                transition: "background-color 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                '@media (max-width: 1450px)': {
                                    width: "42px",
                                    height: "42px",
                                },
                                '@media (max-width: 1200px)': {
                                    width: "36px",
                                    height: "36px",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 22,
                                    },
                                },
                                [MEDIA_MAX_1023]: {
                                    width: "48px",
                                    height: "48px",
                                    "& .MuiSvgIcon-root": {
                                        fontSize: 24,
                                    },
                                },
                                [MEDIA_MAX_599]: {
                                    width: "48px",
                                    height: "48px",
                                },
                            }}>
                            {isOpen ?
                                <RemoveIcon sx={{
                                    color: (theme) => theme.palette.primary.main,
                                    transition: "transform 0.3s ease",
                                }}/> :
                                <AddIcon sx={{
                                    color: "white",
                                    transition: "transform 0.3s ease",
                                }}/>}
                        </Box>
                    </Box>
                })}
            </Box>
        </Box>
        </Box>
        <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
            return {...alert, open: false}
        })}/>
    </>
}
export default KuhniVersoMebel